import { render, staticRenderFns } from "./marketChart.vue?vue&type=template&id=711b91ba&scoped=true&"
import script from "./marketChart.vue?vue&type=script&lang=js&"
export * from "./marketChart.vue?vue&type=script&lang=js&"
import style0 from "./marketChart.vue?vue&type=style&index=0&id=711b91ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b91ba",
  null
  
)

export default component.exports